/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.chevron-down\":[\"Nuoli alaspäin\"]}");